import { useModelInsightsKpiTimePeriod } from "@features/mmm/hooks/mmm-url-state";
import { ModelInsightsTrackedComponent } from "@pages/mmm/amplitude-tracking/components";
import { MMMTab } from "@pages/mmm/amplitude-tracking/mmm-event";
import { useTrackMMMEvent } from "@pages/mmm/amplitude-tracking/use-track-mmm-event";

import { KpiPeriodSelector } from "../kpi-period-selector";

import { ChannelComparisonButtons } from "./channel-comparison-buttons";
import { ChannelSortSelect } from "./channel-sort-select";

export const ChannelComparisonActions = () => {
  const [dateRange, setDateRange] = useModelInsightsKpiTimePeriod();
  const trackMMMEvent = useTrackMMMEvent(MMMTab.MODEL_INSIGHTS);

  return (
    <div className="flex justify-between items-end gap-2 pt-4 pb-8 relative">
      <KpiPeriodSelector
        className="basis-1/3"
        value={dateRange}
        onChange={(value) => {
          trackMMMEvent({
            component:
              ModelInsightsTrackedComponent.INCREMENTAL_ROAS_PERIOD_SELECTOR,
            action: "onChange",
          });
          setDateRange(value);
        }}
      />
      <ChannelComparisonButtons className="basis-1/3 justify-center" />
      <ChannelSortSelect className="basis-1/3 flex justify-end" />
    </div>
  );
};
